import $http from "../axios";

const state = {};

const getters = {};

const actions = {
  sendCommandToTotem(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`send-command-to-totem`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
